import React from "react";
import { Tooltip } from "./Tooltip";

const Contact = ({ classicHeader, darkTheme }) => {
  return (
    <section
      id="contact"
      className={"section " + (darkTheme ? "bg-dark-2" : "bg-light")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Simple Heading */}
        <h2
          className={
            "text-center text-uppercase mb-3 " +
            (darkTheme ? "text-white" : "text-dark")
          }
        >
          Contact
        </h2>

        {/* Subtitle */}
        <p
          className={
            "text-center mb-5 text-5 " +
            (darkTheme ? "text-light" : "text-dark")
          }
        >
          Let's connect with me 👋
        </p>

        {/* Social Icons */}
        <div className="row justify-content-center">
          <div className="col-md-8 text-center">
            <ul
              className={
                "social-icons justify-content-center " +
                (darkTheme ? "social-icons-muted" : "")
              }
              style={{ gap: "2rem" }} // 增加图标之间的间距
            >
              <li className="social-icons-linkedin">
                <Tooltip text="Linkedin" placement="top">
                  <a
                    href="https://www.linkedin.com/in/weichenzhang/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-linkedin-in fa-2x" />{" "}
                    {/* 增加图标大小 */}
                  </a>
                </Tooltip>
              </li>
              <li className="social-icons-github">
                <Tooltip text="Github" placement="top">
                  <a
                    href="https://github.com/WeichenZhang89"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-github fa-2x" /> {/* 增加图标大小 */}
                  </a>
                </Tooltip>
              </li>
              <li className="social-icons-email">
                <Tooltip text="Gmail" placement="top">
                  <a
                    href="mailto:weichenZhang2025@gmail.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fas fa-envelope fa-2x" /> {/* 增加图标大小 */}
                  </a>
                </Tooltip>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
